import { IModules } from '../contexts/user.context';
import { api } from './api';

const baseUrl = '/super-admin';

export const getModules = () => {
    return api.get(`${baseUrl}/modules`).then(res => res.data.data);
}

export const updateModules = (modules: IModules) => {
    return api.post(`${baseUrl}/modules`, modules).then(res => res.data);
}